export default $client => ({
  email(target, code) {
    return $client.post('verify/email', {
      target: target,
      code: code,
    });
  }
});
